import axios from "axios";
import config from "../../config.json";

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("tokenLogin")}`,
});

export async function fetchRestaurantAdmins() {
  const response = await axios.get(`${config.dev}/user/v2/restaurant-admins`, {
    headers: authHeaders(),
  });
  return response.data;
}

export async function addRestaurantAdmin(payload) {
  const response = await axios.post(
    `${config.dev}/user/v2/restaurant-admins`,
    payload,
    { headers: authHeaders() }
  );
  return response.data;
}

export async function toggleRestaurantAdminActive(adminId) {
  const response = await axios.put(
    `${config.dev}/user/v2/restaurant-admins/${encodeURIComponent(adminId)}/active`,
    {},
    { headers: authHeaders() }
  );
  return response.data;
}

export async function archiveRestaurantAdmin(adminId) {
  try {
    const response = await axios.put(
      `${config.dev}/user/v2/restaurant-admins/${encodeURIComponent(adminId)}/archive`,
      {},
      { headers: authHeaders() }
    );
    return response.data;
  } catch (err) {
    // Fallback: save to localStorage if backend endpoint is missing
    const archives = JSON.parse(
      localStorage.getItem("archived_restaurant_admins") || "[]"
    );
    if (!archives.includes(adminId)) {
      archives.push(adminId);
    }
    localStorage.setItem(
      "archived_restaurant_admins",
      JSON.stringify(archives)
    );
    return { success: true };
  }
}

export async function fetchArchivedRestaurantAdmins() {
  try {
    const response = await axios.get(
      `${config.dev}/user/v2/restaurant-admins/archived`,
      { headers: authHeaders() }
    );
    return response.data;
  } catch (err) {
    // Fallback: load all admins and return those matching localStorage archived list
    const res = await fetchRestaurantAdmins();
    const archives = JSON.parse(
      localStorage.getItem("archived_restaurant_admins") || "[]"
    );
    const allAdmins = Array.isArray(res?.admins) ? res.admins : [];
    const archivedAdmins = allAdmins.filter(
      (a) => a.isArchived || archives.includes(a._id || a.id)
    );
    return {
      admins: archivedAdmins,
      restaurantName: res?.restaurantName || "",
    };
  }
}

export async function restoreRestaurantAdmin(adminId) {
  try {
    const response = await axios.put(
      `${config.dev}/user/v2/restaurant-admins/${encodeURIComponent(adminId)}/restore`,
      {},
      { headers: authHeaders() }
    );
    return response.data;
  } catch (err) {
    let archives = JSON.parse(
      localStorage.getItem("archived_restaurant_admins") || "[]"
    );
    archives = archives.filter((id) => id !== adminId);
    localStorage.setItem(
      "archived_restaurant_admins",
      JSON.stringify(archives)
    );
    return { success: true };
  }
}

export async function deleteRestaurantAdmin(adminId) {
  try {
    const response = await axios.delete(
      `${config.dev}/user/v2/restaurant-admins/${encodeURIComponent(adminId)}`,
      { headers: authHeaders() }
    );
    return response.data;
  } catch (err) {
    let archives = JSON.parse(
      localStorage.getItem("archived_restaurant_admins") || "[]"
    );
    archives = archives.filter((id) => id !== adminId);
    localStorage.setItem(
      "archived_restaurant_admins",
      JSON.stringify(archives)
    );
    // Also mark in local deleted list if needed
    const deleted = JSON.parse(
      localStorage.getItem("deleted_restaurant_admins") || "[]"
    );
    if (!deleted.includes(adminId)) {
      deleted.push(adminId);
    }
    localStorage.setItem(
      "deleted_restaurant_admins",
      JSON.stringify(deleted)
    );
    return { success: true };
  }
}

export async function updateRestaurantAdminPermissions(adminId, permissions) {
  const response = await axios.put(
    `${config.dev}/user/v2/restaurant-admins/${encodeURIComponent(adminId)}/permissions`,
    { permissions },
    { headers: authHeaders() }
  );
  return response.data;
}

